import { dpaPage, privacyPage, type InfoPage as InfoPageContent } from "../i18n/nb";
import { usePageTitle } from "../lib/usePageTitle";

function InfoPage({ page }: { page: InfoPageContent }) {
  usePageTitle(page.title);
  return (
    <article className="page narrow info-page">
      <h1>{page.title}</h1>
      <p className="lead">{page.lead}</p>
      {page.sections.map((s) => (
        <section key={s.heading}>
          <h2>{s.heading}</h2>
          {s.bullets && (
            <ul>
              {s.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          )}
          {s.paragraphs?.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </section>
      ))}
      <p className="muted small">{page.updated}</p>
    </article>
  );
}

/** `/personvern`: privacy notice for FAU parents (ADR-005). */
export function PrivacyPage() {
  return <InfoPage page={privacyPage} />;
}

/** `/databehandling`: data processing information for kommuner. */
export function DpaPage() {
  return <InfoPage page={dpaPage} />;
}
